import { render, staticRenderFns } from "./FeedbackTagButtons.vue?vue&type=template&id=2b48b59f&"
import script from "./FeedbackTagButtons.vue?vue&type=script&lang=js&"
export * from "./FeedbackTagButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports